let constants = {
  BUSINESS_PROFILE_CREATED: "BUSINESS_PROFILE_CREATED",
  MULTICONNECT_REMINDER: "MULTICONNECT_REMINDER",
  BUSINESS_CATEGORY_LIST: [
    "Accommodation and Travel",
    "Alternative Therapy",
    "Building & Renovation",
    "Business Services",
    "Car and Boating",
    "Computing and IT",
    "Education and Tuition",
    "Finance and Insurance",
    "Health and Medical",
    "Home Services",
    "Manufacturing and Industrial",
    "Mining and Agriculture",
    "Organisations and Government",
    "Personal Services",
    "Professional Services",
    "Recreation and Entertainment",
    "Restaurants",
    "Retail - At Home & General",
    "Retail - Clothing & Acessories",
    "Retail - Electrical & Electronics",
    "Retail - Recreation & Hobbies",
    "Sporting and Fitness",
    "Wholesale and Distributors",
    "Advertising",
    "Marketing",
    "Events",
    "Events - Business",
  ],
  EMAIL_NOTIFICATION: "EMAIL_NOTIFICATION",
  PUSH_NOTIFICATION: "PUSH_NOTIFICATION",
  CARD_ISSUED_REMINDER: "CARD_ISSUED_REMINDER",
  // CARD_ISSUED_REMINDER_2: "CARD_ISSUED_REMINDER",
  // CARD_ISSUED_REMINDER_3: "CARD_ISSUED_REMINDER",
  REGISTRATION_BY_BASIC_CARD_SHARED: "REGISTRATION_BY_BASIC_CARD_SHARED",
  REGISTRATION_BY_PAID_CARD_SHARED: "REGISTRATION_BY_PAID_CARD_SHARED",
  REGISTRATION_BY_MULTI_CONNECT: "REGISTRATION_BY_MULTI_CONNECT",
  GENERAL_REGISTRATION: "GENERAL_REGISTRATION",
  POST_MULTI_CONNECT_ATTENDED: "MULTI_CONNECT_ATTENDED",
  EVENT_FORMAT_PAGE: "EVENT_FORMAT",
  EVENT_HOST_PAGE: "EVENT_HOST",
  EVENT_DETAILS_PAGE: "EVENT_DETAILS",
  UPLOAD_IMAGE_PAGE: "UPLOAD_IMAGE",
  EVENT_SPONSOR: "EVENT_SPONSOR",
  EVENT_AGENDA: "EVENT_AGENDA",
  SESSION_SPEAKER: "SESSION_SPEAKER",
  SPEAKER_REMOVED_FROM_SESSION: "SPEAKER_REMOVED_FROM_SESSION",
  MULTI_CONNECT_WIZARD_STEPPER: [
    {
      step: 1,
      stepName: "EVENT_FORMAT",
      header: "Event format",
      content: "EventFormat",
    },
    {
      step: 2,
      stepName: "EVENT_HOST",
      header: "Event host",
      content: "AddEditHostDetails",
    },
    {
      step: 3,
      stepName: "EVENT_DETAILS",
      header: "Event details",
      content: "AddEditEventDetails",
    },
    {
      step: 4,
      stepName: "UPLOAD_IMAGE",
      header: "Upload image",
      content: "UploadImages",
    },
    {
      step: 5,
      stepName: "EVENT_SPONSOR",
      header: "Featured Profiles",
      content: "AddEditSponsors",
      props: {isEditingMCEvent: false}
    },
  ],
  MULTI_CONNECT_WIZARD_STEPPER_WITH_SUB_EVENTS: [
    {
      step: 1,
      stepName: "EVENT_HOST",
      header: "Event host",
      content: "AddEditHostDetails",
    },
    {
      step: 2,
      stepName: "EVENT_DETAILS",
      header: "Event details",
      content: "AddEditEventDetails",
      props: {isEditMode: false}
    },
    {
      step: 3,
      stepName: "UPLOAD_IMAGE",
      header: "Upload image",
      content: "UploadImages",
    },
    {
      step: 4,
      stepName: "EVENT_SPONSOR",
      header: "Sponsors",
      content: "AddEditSponsors",
      props: {isEditingMCEvent: false}
    },
  ],
  MULTI_CONNECT_WIZARD_STEPPER_WITH_SUB_EVENTS_PUBLIC_EVENT: [
    {
      step: 1,
      stepName: "EVENT_FORMAT",
      header: "Event format",
      content: "EventFormat",
    },
    {
      step: 2,
      stepName: "EVENT_HOST",
      header: "Event host",
      content: "AddEditHostDetails",
    },
    {
      step: 3,
      stepName: "EVENT_DETAILS",
      header: "Event details",
      content: "AddEditEventDetails",
      props: {isEditMode: false}
    },
    {
      step: 4,
      stepName: "UPLOAD_IMAGE",
      header: "Upload image",
      content: "UploadImages",
    },
    {
      step: 5,
      stepName: "EVENT_SPONSOR",
      header: "Sponsors",
      content: "AddEditSponsors",
      props: {isEditingMCEvent: false}
    },
  ],
  MULTI_CONNECT_ANALYTICS: {
    SPONSOR: "SPONSOR_ANALYTICS",
    PROMOTION: "PROMOTION_ANALYTICS",
  },
  EVENT_CATEGORY: {
    subEvent: "subEvent",
    session: "session",
    superConnect: "superConnect",
    multiConnect: "multiConnect"
  },
  MULTI_CONNECT_EVENT_TYPE: ["Awards",
    "Charity",
    "Charity Golf Day",
    "Conference",
    "Festival",
    "Fundraiser",
    "Golf Day",
    "Launch",
    "Masterclass",
    "Networking",
    "Other",
    "Party",
    "Seminar",
    "Speaker Session",
    "Summit",
    "Trade show/expo",
    "Webinar",
    "Workshop"]
};

export default constants;
